import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Info from './Info';
 
function Video() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [faq, setFaq] = useState([]);
    const [posting_ad, setPostingAd] = useState([]);
    const [marketing_tips, setMarketingTips] = useState([]);
    const [sales_tips, setSalesTips] = useState([]); 
    useEffect(() => {
        document.title = 'Infomart | User Help';
        setIsLoading(true);
        axios.get(`${BASE_URL}/user/faq`, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setFaq(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        axios.get(`${BASE_URL}/user/posting-ad`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setPostingAd(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        axios.get(`${BASE_URL}/user/marketing-tips`, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setMarketingTips(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        axios.get(`${BASE_URL}/user/sales-tips`, {
            headers: {   
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => { 
            setSalesTips(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });   
    }, []);
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className={styles.helpPageContainer}>
                            <div className={styles.helpPageMain}>
                                <div className={styles.helpPageLeft}>
                                    <h4 className="mb-4">Help for Commomn Questions</h4>
                                    <div className="text-muted">If your question is not answered below, please <span><Link to="/user/contact-us">contact us</Link></span>.</div> 
                                    {faq?.map((data, i) => ( 
                                        <div className={styles.questionBox} key={i}>  
                                            <h6>{data.question}</h6>
                                            <div>{data.answer}</div>
                                            <div className={styles.spaceRow}>
                                                <a href={data.tutorial} target="_blank">View Tutorial</a>
                                                {/* <a href="#">Top of Page</a>  */}
                                            </div>  
                                        </div> 
                                    ))}   
                                </div>
                                <div className={styles.helpPageRight}>
                                    <div className={styles.rightBox}>
                                        <h6 className="text-primary">Posting an Ad</h6>
                                        <ul style={{ marginLeft: 0 }}>
                                            {posting_ad?.map((data, i) => (
                                                <li key={i}>{data.text}</li>
                                            ))}  
                                        </ul> 
                                    </div> 
                                    <div className={styles.rightBox}>
                                        <h6 className="text-primary">Marketing Tips</h6>
                                        <ul style={{ marginLeft: 0 }}>
                                            {marketing_tips?.map((data, i) => (
                                                <li key={i}>{data.tips}</li>
                                            ))}   
                                        </ul> 
                                    </div>
                                    <div className={styles.rightBox}>
                                        <h6 className="text-primary">Sales Tips</h6>
                                        <ul style={{ marginLeft: 0 }}>
                                            {sales_tips?.map((data, i) => (
                                                <li key={i}>{data.tips}</li>
                                            ))}    
                                        </ul> 
                                    </div> 
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Video;          